import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService } from '@common/util-foundation';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AppliancesApiService } from '@common/data-access-appliance-details';
import * as BrandsActions from './brands.actions';

@Injectable()
export class BrandsEffects {
  loadBrands$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BrandsActions.loadBrands),
      switchMap(({ applianceCode }) =>
        this.appliancesService.getBrandsForAppliance(applianceCode).pipe(
          map((brands) =>
            BrandsActions.loadBrandsSuccess({ brands, applianceCode })
          ),
          catchError((error: HttpErrorResponse) => {
            this.handleError();
            return of(
              BrandsActions.loadBrandsFailure({ error, applianceCode })
            );
          })
        )
      )
    )
  );

  handleError() {
    this.errorService.handleError();
  }

  constructor(
    private actions$: Actions,
    private appliancesService: AppliancesApiService,
    private errorService: ErrorService
  ) {}
}
